import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";

import { Button, Confirm } from "semantic-ui-react";

import { ApplicationState } from "../../../../applicationState";

import { ReferAgainPaths } from "./referAgainRoutes";

import { push } from "redux-little-router";

interface Props {
    referCaseAgainSubpath: ReferAgainPaths;
}

export const ReferAgainButton: React.FunctionComponent<Props> = (props: Props) => {
    const [referAgainModalOpen, setReferAgainModalOpen] = React.useState<boolean>(false);

    const currentPath = useSelector((state: ApplicationState) => state.router.pathname);

    const onReferAgain = () => setReferAgainModalOpen(true);

    const onReferAgainCancel = () => setReferAgainModalOpen(false);

    const dispatch = useDispatch();
    const onReferAgainConfirm = () => {
        setReferAgainModalOpen(false);
        dispatch(push(`${currentPath}/${props.referCaseAgainSubpath}`));
    };

    return (
        <>
            <Button onClick={onReferAgain}>Refer Again</Button>
            <Confirm
                open={referAgainModalOpen}
                // eslint-disable-next-line max-len
                content="By selecting this option you will open a new referral form for this employee populated with all of the personal details provided on the previous referral form linked to this case. Please ensure you check all of these details carefully before you submit the referral as they may have changed since your last referral to us. Press 'Yes' to proceed."
                cancelButton="No"
                confirmButton="Yes"
                onCancel={onReferAgainCancel}
                onConfirm={onReferAgainConfirm}
            />
        </>
    );
};
